module.exports = __webpack_public_path__ + "static/media/1ad36221.jpg";